import * as React from 'react'
import { toast } from 'react-toastify'
import { homeService, itemService, userService } from '../../../../services'
import { Button, Divider, Grid, Header, Icon, Segment } from 'semantic-ui-react'
import { GameItemDeck } from '../../components'
import { common } from '../../../../utils/common'
import { InfoTab } from './components/InfoTab'
import MarqueeBanner from './containers/MarqueeBanner'
import { DepositLink } from './components/DepositLink'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

type RollItemStoreUserProps = {
    user: IUser
}

type RollItemStoreUserState = {
    isLoading: boolean,
    availableRollItems: IGameItem[],
    pickedRollItems: IGameItem[],
    showDeposit: boolean,
    showModalSuccess: boolean
}

export default class RollItemStoreUser extends React.Component<RollItemStoreUserProps, RollItemStoreUserState> {
    constructor(props: RollItemStoreUserProps) {
        super(props)
        this.state = ({
            isLoading: true,
            availableRollItems: [],
            pickedRollItems: [],
            showDeposit: false,
            showModalSuccess: false
        })
    }

    componentDidMount() {
        this.getAvailableItem()
    }

    getAvailableItem = async () => {
        try {
            this.setState({isLoading: true})
            const response = await itemService.getRollItems()
            this.setState({
                isLoading: false,
                availableRollItems: response,
                pickedRollItems: []
            })
        } catch (error) {
            toast.error(error.message)
        }
    }

    handlePickItem = (item: IGameItem) => {
        let {availableRollItems} = this.state
        let {user} = this.props
        const indexItem = availableRollItems.indexOf(item)
        if (indexItem >= 0) {
            let newStateItems = availableRollItems.filter((v, i) => i !== indexItem)
            let pickedRollItems = this.state.pickedRollItems.concat(item)
            if ((common.calculatePickedVnd(pickedRollItems) > user.amount)) {
                this.setState({
                    availableRollItems: newStateItems,
                    pickedRollItems: pickedRollItems,
                    showDeposit: true,
                })
            } else {
                this.setState({
                    availableRollItems: newStateItems,
                    pickedRollItems: pickedRollItems,
                    showDeposit: false,
                })
            }
        }
    }

    handleRemoveItem = (item: IGameItem) => {
        const items = this.state.pickedRollItems
        const index = items.indexOf(item)
        const {user} = this.props
        const pickedRollItems = items.filter((v, i) => i !== index)
        const showDeposit = common.calculatePickedVnd(pickedRollItems) > user.amount
        if (index >= 0) {
            this.setState({
                    pickedRollItems: pickedRollItems,
                    availableRollItems: this.state.availableRollItems.concat(item),
                    showDeposit: showDeposit,
                }
            )
        }
    }

    onClickBuyItem = async () => {
        let {pickedRollItems} = this.state
        let {user} = this.props
        if (!user.steamId) {
            toast.error('Bạn chưa thiết lập thông tin steamID! ' +
                'Bạn vui lòng bổ sung thông tin steamId ở trang profile! Xin cảm ơn!')
            return
        }
        if (!pickedRollItems || pickedRollItems.length <= 0) {
            toast.error('Bạn chưa chọn item để mua!')
            return
        }
        this.setState({
            isLoading: true,
        })
        const rollRequestInfo = {gameItems: pickedRollItems, steamId: user.steamId}
        userService.doRollByUser(rollRequestInfo)
            .then(rollResult => {
                if (rollResult.status === 'DONE') {
                    toast.success('Mua hàng thành công!')
                    this.setState({
                        showModalSuccess: true,
                        isLoading: false,
                        pickedRollItems: [],
                    })
                } else {
                    toast.error('Mua hàng không thành công!')
                    this.setState({
                        isLoading: false,
                    })
                }
                homeService.getAppState()
            })
            .catch(error => {
                toast.error('Mua hàng không thành công! Thông tin: ' + error.message)
                this.setState({
                    isLoading: false
                })
                homeService.getAppState()
            })
    }

    render() {
        let {isLoading, availableRollItems, pickedRollItems, showDeposit} = this.state
        const {user} = this.props
        return (
            <div>
                <MarqueeBanner/>
                <div className="container store">
                    <Segment loading={isLoading} style={{border: 'none', paddingBottom: '70px'}}>
                        <InfoTab/>
                        <Divider horizontal={true}/>

                        <Grid columns="2" stackable={true} style={{border: 'none'}}>
                            <Grid.Column>
                                <Header as="h3" attached="top">
                                    Chọn Item ~
                                    <span style={{color: 'red'}}>
                  Tài khoản bạn còn:{' ' +
                                    common.showRemainAmount(common.calculatePickedVnd(pickedRollItems), user)
                                        .toLocaleString('vn') + ' vnd'}
                </span>
                                    <Button
                                        floated={'right'}
                                        size={'mini'}
                                        color={'blue'}
                                        onClick={() => window.location.reload()}
                                    >
                                        <Icon name="refresh"/>Tải lại
                                    </Button>
                                </Header>
                                <GameItemDeck items={availableRollItems} onClickItem={this.handlePickItem}/>
                            </Grid.Column>
                            <Grid.Column>
                                <Header as="h3" attached="top">
                                    Tổng giá
                                    trị: {common.calculatePickedValue(pickedRollItems)}
                                    ~ {common.calculatePickedVnd(pickedRollItems).toLocaleString('vn') + 'vnd'}
                                </Header>
                                <GameItemDeck
                                  items={pickedRollItems}
                                  onClickItem={this.handleRemoveItem}
                                  isCart={true}
                                />
                                {showDeposit &&
                                <DepositLink
                                    money={
                                        common.showRemainAmount(common.calculatePickedVnd(pickedRollItems), user) * -1
                                    }
                                />}
                                {!showDeposit && <Button color={'blue'} onClick={this.onClickBuyItem}>Mua</Button>}
                                <Divider/>
                            </Grid.Column>
                        </Grid>
                    </Segment>
                </div>
                <Modal
                    isOpen={this.state.showModalSuccess}
                    toggle={() => this.setState({
                        showModalSuccess: !this.state.showModalSuccess
                    })}
                >
                    <ModalHeader>Mua hàng thành công</ModalHeader>
                    <ModalBody>
                        ✨ Value của bạn đã ở túi của bạn trên 5etop ✨
                        <br/>Xin chân thành cảm ơn 🎉
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/RollItemStore/RollItemStoreUser.tsx